import { darken } from "polished";
import styled from "styled-components";
import ButtonNormal from "./ButtonNormal";

const ButtonDanger = styled(ButtonNormal)`
    background-color: #E37777;
    color: #ffffff;

    :hover {
        background-color: ${darken(0.1, '#E37777')};
    }

    :disabled {
        background-color: ${p => p.theme.colors.bgDisabled};
    }
`;

export default ButtonDanger;